import { useState } from "react";

import { Button } from "@sso/ui/Button";
import { Flex } from "@sso/ui/FlexBox";

interface ProductCardActionProps {
  url: string;
}
export const ProductCardAction = ({ url }: ProductCardActionProps) => {
  const [startOpening, setStartOpening] = useState(false);

  const handleOpenProduct = () => {
    setStartOpening(true);
    global.window.open(url, "_self")?.focus();
  };

  return (
    <Flex margin="auto 0 1rem 0" width="100%">
      <Flex position="relative" width="100%" margin="0 0.5rem">
        <Button disabled={startOpening} fullWidth margin="0" onClick={handleOpenProduct}>
          {startOpening ? "Waiting..." : "Start Now"}
        </Button>
      </Flex>
    </Flex>
  );
};
